import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from 'react';
import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/shared/components/button';
import { Icon } from 'src/shared/components/icon';
function handleUploadFiles() {
    window.dispatchEvent(new CustomEvent('app-content-admin:contentlist:upload-files'));
}
export function UploadFilesButton() {
    const { t } = useTranslation();
    const uploadFilesButtonTextId = useId();
    return (_jsx(Button, { variation: "secondary", onClick: handleUploadFiles, icon: _jsx(Icon, { icon: faArrowUpFromBracket, "aria-labelledby": uploadFilesButtonTextId }), children: _jsx("span", { id: uploadFilesButtonTextId, className: "hidden md:block", children: t('content_list.tools.upload_files') }) }));
}
